export const EMAIL_REGEX =
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
export const PASSWORD_SPECIALS_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).$/;
export const linkToTermsOfUse = 'https://www.airthings.com/terms-of-use';
export const API_URL_DEV = 'https://accounts-api.{{environment}}.airthings.com/v1';
export const API_URL_PROD = 'https://accounts-api.airthings.com/v1';
export const DASHBOARD_LOGIN_LINK =
    '/login?client_id=54d05b44-882e-48d8-8d89-28d247d9f993&redirect_uri=https://dashboard.airthings.com';

export const accessTokenLocalStoragePath = 'airthingsAccounts.accessToken';
export const expiresAtLocalStoragePath = 'airthingsAccounts.expiresAt';

export const paths = {
    login: '/login',
    registration: '/registration',
    authorizePath: '/authorize',
    verify: '/verify',
    resendConfirmationCode: '/resend-confirmation-code',
    resetPassword: '/reset-password',
    notSupported: '/not-supported',
    singleSignOnLogin: '/sso-login',
    singleSignOnValidation: '/federated',
    singleSignOnTAndC: '/terms-and-conditions',
};

export const ssoRedirectUri = paths.singleSignOnValidation;

export const pathsOutsideLogin = [
    paths.registration,
    paths.login,
    paths.singleSignOnValidation,
    paths.singleSignOnLogin,
];
